module.exports = __webpack_public_path__ + "static/media/Export.ea406f85.svg";